import script from "./sivReport.vue?vue&type=script&setup=true&lang=js"
export * from "./sivReport.vue?vue&type=script&setup=true&lang=js"

import "./sivReport.vue?vue&type=style&index=0&id=645e91cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-645e91cc"]])

export default __exports__